import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

/**
 * Precomputed compound-character links for a component grapheme.
 *
 * `graphemeId` is the component/primitive. `compoundGraphemeId` is the character that uses it.
 * Each nullable order column is 1-based within that component and grading set, sorted by SUBTLEX
 * character rank. `null` means the compound is not part of that grading set.
 */
export const graphemeCompoundGraphemeTable = staticTable(
  "grapheme_compound_grapheme",
  {
    compoundGraphemeId: integer("compound_grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),

    hsk2010Order: integer("hsk_2010_order"),
    hsk2021Order: integer("hsk_2021_order"),
    hsk2026Order: integer("hsk_2026_order"),
    tbclOrder: integer("tbcl_order"),
  },
  (table) => [
    index("grapheme_compound_grapheme_grapheme_id_idx").on(table.graphemeId),
    index("grapheme_compound_grapheme_compound_grapheme_id_idx").on(table.compoundGraphemeId),
    index("grapheme_compound_grapheme_hsk_2010_order_idx").on(table.graphemeId, table.hsk2010Order),
    index("grapheme_compound_grapheme_hsk_2021_order_idx").on(table.graphemeId, table.hsk2021Order),
    index("grapheme_compound_grapheme_hsk_2026_order_idx").on(table.graphemeId, table.hsk2026Order),
    index("grapheme_compound_grapheme_tbcl_order_idx").on(table.graphemeId, table.tbclOrder),
  ],
);

export type GraphemeCompoundGrapheme = typeof graphemeCompoundGraphemeTable.$inferSelect;
